import { css as r } from "@microsoft/fast-element";
import { normalize as i } from "../common/normalize.js";
import { display as t, PropertyStyleSheetBehavior as a } from "@matrix42/fast-foundation";
import { typography as e } from "../styles/typography.js";
import { designTokens as o } from "../design-tokens.js";
const l = r`
  :host {
    display: none;
  }
`, h = r`
  ${i}
  ${t("flex")}
  .control {
    border: ${o.borderWidth.sm} solid
      ${o.color.neutral[40]};
    border-radius: ${o.borderRadius.xs};
    overflow: clip;

    width: 100%;

    /* Typography */
    ${e("p", "regular")};

    box-shadow: ${o.shadow.box.sm};

    background-color: ${o.color.white};
  }

  .header {
    display: flex;
    justify-content: space-between;
    flex: 1 0 0;

    align-items: center;

    padding: 0 ${o.spacing[4]};

    height: ${o.spacing[12]};
    background-color: ${o.color.neutral[30]};
  }

  .title {
    color: ${o.color.neutral[500]};
    /* Typography */
    ${e("h6", "semibold")};
  }

  .header-actions {
    display: flex;
    gap: ${o.spacing[2]};
  }

  .body {
    padding: ${o.spacing[4]};
    overflow: auto;
    height: calc(100% - ${o.spacing[12]});
  }
`.withBehaviors(new a("open", !1, l));
export {
  h as popUpWidgetStyles
};
